import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Device } from '@rocksoft/shared';

export function selectUnenrolledDeviceId(device: Device) {
  return device.udid;
}

export const adapter: EntityAdapter<Device> = createEntityAdapter<Device>({
  selectId: selectUnenrolledDeviceId,
});

export type UnenrolledDeviceState = EntityState<Device>;

export const initialState: UnenrolledDeviceState = adapter.getInitialState();
